import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import { ReactComponent as WheelchairIcon } from '../../assets/images/svg/wheelchair.svg';
import FooterLink, { FooterText } from '../FooterLink/FooterLink';
import { variables } from '../../assets/styles/variables';
import { mediaBelow, pxToRem, pxToRemMd } from '../../assets/styles/helper';
import themeColors from '../../assets/styles/themeColors';
import { uFlexCenter, uFullWidth } from '../../assets/styles/utility';

const FooterWrapper = styled.div`
  ${uFlexCenter};
  ${uFullWidth};
  padding: ${pxToRem(12)} 0;
  background-color: ${themeColors.colorFooterBackground};

  ${mediaBelow(variables.breakpoints.bpXxl)} {
    flex-direction: column-reverse;
    align-items: center;
    padding: ${pxToRemMd(16)} 0;
  }
`;

const FooterCopyright = styled.p`
  color: ${themeColors.colorFooterText};
  margin-right: ${pxToRem(48)};
  text-align: center;
  font-size: ${pxToRem(12)};

  ${mediaBelow(variables.breakpoints.bpXxl)} {
    margin-right: 0;
    margin-top: ${pxToRemMd(16)};
    font-size: ${pxToRemMd(11)};
    line-height: 2;
  }
`;

const FooterList = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;

  & > :not(:last-child) {
    &:after {
      content: '|';
      display: inline;
      font-size: ${pxToRem(16)};
      line-height: 1.5;
      color: ${themeColors.colorFooterText};
      margin: 0 ${pxToRem(16)};
    }
  }

  ${mediaBelow(variables.breakpoints.bpXl)} {
    display: flex;
    align-items: center;
    list-style: none;

    & > :not(:last-child) {
      &:after {
        font-size: ${pxToRemMd(12)};
      }
    }

    ${mediaBelow(variables.breakpoints.bpLg)} {
        display: flex;
        align-items: center;
        justify-content: center;
        list-style: none;
        flex-direction: column;
    
        & > :not(:last-child) {
          &:after {
            display: none;
          }
        }
  }
`;

const FooterItem = styled.li`
  cursor: pointer;
`;

const Footer = () => {
  const { t } = useTranslation();
  const settings = useSelector(selectSettings);
  const date = new Date();
  const copyrightYear = date.getFullYear();
  const { Copyright } = settings;

  const footerData = settings?.FooterUrls?.map(
    (item) => item && { label: item.Caption, value: item.Url },
  );

  return (
    <FooterWrapper>
      <FooterCopyright>
        {t(`footer.copyright`, {
          year: copyrightYear,
          Copyright,
          interpolation: { escapeValue: false },
        })}
      </FooterCopyright>
      <FooterList>
        <>
          {footerData &&
            footerData.map(({ label, value }) => (
              <FooterItem key={label}>
                <FooterLink type="website" value={value} text={label} />
              </FooterItem>
            ))}

          <FooterItem>
            <FooterText data-acsb="trigger">
              <WheelchairIcon />
              {t(`footer.menu.accessibilityAssistant`)}
            </FooterText>
          </FooterItem>
        </>
      </FooterList>
    </FooterWrapper>
  );
};

export default Footer;
